/**
 * BIRHAUS v3.0 Spacing System
 * Generous whitespace for cognitive comfort
 * All values 2x larger than traditional scales for breathing room
 */

export const spacingV3 = {
  0: '0px',
  0.5: '4px',    // NEW micro spacing
  1: '8px',      // base unit (doubled from 4px)
  1.5: '12px',   // NEW
  2: '16px',     // doubled from 8px
  2.5: '20px',   // NEW
  3: '24px',     // doubled from 12px
  4: '32px',     // doubled from 16px
  5: '40px',     // doubled from 20px
  6: '48px',     // doubled from 24px
  7: '56px',     // NEW
  8: '64px',     // doubled from 32px
  9: '72px',     // NEW
  10: '80px',    // doubled from 40px
  12: '96px',    // doubled from 48px
  14: '112px',   // NEW
  16: '128px',   // doubled from 64px
  20: '160px',   // doubled from 80px
  24: '192px',   // doubled from 96px
  32: '256px',   // NEW for hero sections
  40: '320px',   // NEW for large sections
} as const

// Semantic spacing for different layout purposes
export const layoutSpacingV3 = {
  // Section spacing (vertical rhythm)
  'section-xs': spacingV3[8],   // 64px
  'section-sm': spacingV3[12],  // 96px
  'section-md': spacingV3[16],  // 128px
  'section-lg': spacingV3[20],  // 160px
  'section-xl': spacingV3[24],  // 192px
  'section-2xl': spacingV3[32], // 256px
  
  // Content spacing (within sections)
  'content-xs': spacingV3[4],   // 32px
  'content-sm': spacingV3[6],   // 48px
  'content-md': spacingV3[8],   // 64px
  'content-lg': spacingV3[10],  // 80px
  'content-xl': spacingV3[12],  // 96px
  
  // Element spacing (between components)
  'element-xs': spacingV3[2],   // 16px
  'element-sm': spacingV3[3],   // 24px
  'element-md': spacingV3[4],   // 32px
  'element-lg': spacingV3[6],   // 48px
  'element-xl': spacingV3[8],   // 64px
  
  // Compact spacing (within components)
  'compact-xs': spacingV3[1],   // 8px
  'compact-sm': spacingV3[1.5], // 12px
  'compact-md': spacingV3[2],   // 16px
  'compact-lg': spacingV3[2.5], // 20px
  'compact-xl': spacingV3[3],   // 24px
} as const

// Component-specific spacing presets
export const componentSpacing = {
  // Button padding
  button: {
    xs: spacingV3[2],    // 16px
    sm: spacingV3[3],    // 24px
    md: spacingV3[4],    // 32px
    lg: spacingV3[5],    // 40px
    xl: spacingV3[6],    // 48px
  },
  
  // Card padding
  card: {
    sm: spacingV3[4],    // 32px
    md: spacingV3[6],    // 48px
    lg: spacingV3[8],    // 64px
    xl: spacingV3[10],   // 80px
  },
  
  // Input padding
  input: {
    sm: spacingV3[3],    // 24px
    md: spacingV3[4],    // 32px
    lg: spacingV3[5],    // 40px
  },
  
  // Container margins
  container: {
    sm: spacingV3[6],    // 48px
    md: spacingV3[8],    // 64px
    lg: spacingV3[12],   // 96px
    xl: spacingV3[16],   // 128px
  },
} as const